import { Box, useColorModeValue } from '@chakra-ui/react';
import FormulaEditor from './FormulaEditor';
import FormulaIcon from './FormulaIcon';
import { SheetDefaults } from '../../../constants/sheetDefaults';

interface FormulaBarProps {
  isVisible?: boolean;
  height?: number;
}

const FormulaBar: React.FC<FormulaBarProps> = ({
  isVisible = true,
  height = SheetDefaults.formulaBarHeight,
}) => {
  // const background = useColorModeValue('#f5f8fa', '#161718');

  return isVisible ? (
    <Box
      height={`${height}px`}
      display="flex"
      padding="1px"
      pl="2"
      pr="2"
      // background={background}
      alignItems="center"
      position={'absolute'}
      zIndex={3}
      width={'100%'}
    >
      <FormulaIcon />
      <FormulaEditor />
    </Box>
  ) : null;
};

export default FormulaBar;
